import { Modal, Skeleton } from "antd";
import { useError } from "../hooks/useError";
import { ContainerAssinatura, TitleAssinatura } from "../styles";
import { useState, useEffect } from "react";
import { useAtualizarAssinaturas } from "../hooks/useAtualizarAssinaturas";
import { useSuccess } from "../hooks/useSuccess";
import { useNavigate } from "react-router-dom";

export default function ModalAtivarAssinatura({
  isModalOpen,
  handleFechar,
  assinaturaId,
  cotaUsuarioId,
}: any) {
  const { success, isLoading, error, atualizarAssinatura, resetError } =
    useAtualizarAssinaturas(assinaturaId, "ATIVA", cotaUsuarioId);
  const { showError, contextHolder } = useError();
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  const [errorDisplayed, setErrorDisplayed] = useState(false); // Estado para controlar se o erro já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isModalOpen) {
      if (success && !successDisplayed) {
        showSuccess(success);
        setSuccessDisplayed(true);

        setTimeout(() => {
          setSuccessDisplayed(false);
          navigate(0);
        }, 3000);
      }

      if (error && !errorDisplayed) {
        showError(error);
        setErrorDisplayed(true);

        setTimeout(() => {
          setErrorDisplayed(false);
          resetError(); // Reseta o erro no hook
        }, 3000);
      }
    } else {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    showError,
    errorDisplayed,
    successDisplayed,
    navigate,
    error,
    resetError, // Adicione a função resetError às dependências
  ]);

  return (
    <>
      {/* Exibe a mensagem de erro */}
      <div key="error-message-holder">{contextHolder}</div>
      <div key="success-message-holder">{successContextHolder}</div>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Ativar"
        onOk={atualizarAssinatura} // Chama a função para ativar a assinatura ao clicar em "Ativar"
        confirmLoading={isLoading} // Mostra o estado de carregamento no botão "Ativar"
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoading && <Skeleton active />}
        {!isLoading && (
          <ContainerAssinatura>
            <TitleAssinatura>Gostaria de ativar a assinatura? </TitleAssinatura>
            {/* <TextAssinatura>Assinatura ID: {assinaturaId}</TextAssinatura> */}
          </ContainerAssinatura>
        )}
      </Modal>
    </>
  );
}
